import Link from "next/link";
import ArrowRight from "assets/svgs/button-arrow-right.svg";

/**
 *
 * @param {object} region { name: string, slug: string }
 * @param {object} caseData { name: string, slug: string }
 * @returns
 */
export default function Breadcrumbs({ region, city, caseData }) {
  return (
    <div className="text-xs text-left mb-6">
      <ul className="flex flex-wrap">
        <li className="mt-1">
          <Link href="/cases">
            <a className="opacity-70 hover:underline hover:opacity-90">
              All Cases
            </a>
          </Link>
        </li>

        {region && (
          <>
            <li className="flex justify-center align-center mt-1 mx-3 opacity-70">
              <ArrowRight width="6" />
            </li>
            <li className="mt-1">
              <Link href={region.url ? region.url : `/states/${region?.slug}-cold-cases`}>
                <a className="opacity-70 hover:underline hover:opacity-90">
                  {region?.name}
                </a>
              </Link>
            </li>
          </>
        )}

        {city && (
          <>
            <li className="flex justify-center align-center mt-1 mx-3 opacity-70">
              <ArrowRight width="6" />
            </li>
            <li className="mt-1">
              <Link href={city.url ? city.url : `/cases/${city?.slug}`}>
                <a className="opacity-70 hover:underline hover:opacity-90">
                  {city?.name}
                </a>
              </Link>
            </li>
          </>
        )}

        {caseData && (
          <>
            <li className="flex justify-center align-center mt-1 mx-3 opacity-70">
              <ArrowRight width="6" />
            </li>
            <li className="mt-1">
              <Link href={`/cases/${caseData?.slug}`}>
                <a className="opacity-70 hover:underline hover:opacity-90">
                  {caseData?.name}
                </a>
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
